import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { HeadWiseReport } from "../../components/HeadWiseReport";
import { TerritoryGateSkeleton } from "../../components/TerritoryGate";
import { useMeState, useRoleModules } from "../../lib/roleModules";
import { useAuth } from "../../context/AuthContext";

/** Phase 230 — Supervisor › Head-wise Collection: the same report as the Admin page, every figure limited to the
 *  supervisor's mapped zone(s) (server-side territory scoping). Module `head_wise`: "View only" = on screen only,
 *  "Full access" = Excel / PDF too. A municipal admin opening the Supervisor console sees the whole municipality. */
export default function SupervisorHeadWise() {
  const { code } = useParams();
  const { auth } = useAuth();
  const access = useRoleModules(code);
  const { me, loading } = useMeState(code);
  const isSupervisor = auth?.user?.role === "supervisor";
  const status = me?.territory_status;
  const lockedZoneIds = useMemo(() => (isSupervisor ? (status?.zone_ids || []) : null), [isSupervisor, status]);

  if ((loading && isSupervisor) || !access.loaded) return <TerritoryGateSkeleton />;
  const zones = isSupervisor ? (status?.zones || []) : [];
  const canDownload = isSupervisor ? access.levelOf("head_wise") === "write" : true;
  return (
    <HeadWiseReport code={code} testIdPrefix="sup-head-wise"
      subtitle={isSupervisor
        ? `Demand, collected and outstanding per tax head for your mapped zone${zones.length > 1 ? "s" : ""}${zones.length ? ` — ${zones.join(", ")}` : ""}`
        : "Demand, collected and outstanding per tax head"}
      canDownload={canDownload}
      lockedZoneIds={lockedZoneIds}
      scopeZoneNames={zones}
      areaLevels={["zone", "ward", "mohalla"]} />
  );
}
